import { useDispatch } from 'react-redux';
import { ComputationTabs } from '../../../../../types/type'
import { setIsUpdateRates, setRatesTabs } from '../../../../../features/actuarial/rates-slice';
import { setIsUpdateAnnualPremiumAndIoE } from '../../../../../features/actuarial/annual-premium-eoi.slice';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useProposalData } from '../../../../../hooks/populate-data/use-proposal-data';
import { setIsEditingNotesForProposal, setNoteForProposalAct } from '../../../../../features/actuarial/remark-slice';
import { useProposalComputation } from '../../../../../hooks/proposal/use-proposal-computation';

export default function ProposalComputationTabs() {
    
    const { populateRates, populateEvidenceNotes, populateTotalAmount } = useProposalData()
    const dispatch = useDispatch()
    const { isPrototype } = useProposalTypeData();
    const { ratesActiveTab } = useProposalComputation();

    const handleSelect = (type: ComputationTabs) => {
        dispatch(setRatesTabs(type))
        populateRates();
        populateEvidenceNotes();
        populateTotalAmount();
        dispatch(setIsUpdateRates(false))
        dispatch(setIsUpdateAnnualPremiumAndIoE({ isUpdate: false, type: 'evidenceOfInsurability' }))
        dispatch(setIsUpdateAnnualPremiumAndIoE({ isUpdate: false, type: 'annualPremium' }))
        dispatch(setIsEditingNotesForProposal(false));
        dispatch(setNoteForProposalAct({
            isShow: false,
            notesProposal: "",
            showCKEdit: false,
            copyNotes: "",
        }));
    }

    const tabs = [
        { value: "rates", label: "Rates" },
        { value: "eoi", label: "Premium and EoI" },
        { value: "actDocuments", label: "Documents" },
        { value: "actNotes", label: "Remarks" },
    ] satisfies { value: ComputationTabs; label: string; }[];

    if (isPrototype) return null;

    return (
        <div className="shrink-0 border-b border-gray-200 bg-white px-2 pt-2 md:px-3 lg:px-4">
            <div className="grid w-full grid-cols-4 overflow-hidden rounded-t-lg border border-gray-200 bg-gray-100">
                {tabs.map((tab) => {
                    const isActive = ratesActiveTab === tab.value
                    return (
                        <button
                            key={tab.value}
                            type="button"
                            onClick={() => handleSelect(tab.value)}
                            className={`group relative flex min-w-0 items-center justify-center gap-1.5 px-2 py-2.5 text-[11px] font-medium transition-all duration-150 md:gap-2 ${isActive ? 'bg-[#186cb2] text-white shadow-sm' : 'bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700'}`}
                        >
                            {tab.label}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
